import { Component } from 'react';
import Inline from '../Inline';
import { apiDeleteP, apiGetP, apiPostP } from '../../GanjiTools';
import FontAwesomeIcon from '../utils/FontAwesomeIcon';
import SideDivider from '../layout/SideDivider';
import MasterLayout from '../layout/MasterLayout';
import MinimalButton from '../MinimalButton';
import Theme from '../theme/Theme';
import Missions from './Missions';
import { UniGrid } from '../UniGrid';
import MoneyInOut from './MoneyInOut';
import { Button, Popup } from 'devextreme-react';
import Deal from './Deal';
import ShareHolderReports from './ShareHolderReports';
import { AuxFile } from './AuxFile';
import CustomerReports from './CustomerReports';
import DriverReports from './DriverReports';
import Welcome from './Welcome';
import TankerReports from './TankerReports';
import ViewDocuments from './ViewDocuments';
import Uploader from '../Uploader';
import { SimpleItem } from 'devextreme-react/form';
import TarabarLogon from './TarabarLogon';
import { Background } from 'devextreme-react/range-selector';

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            serverIsConnected: false,
            mode: this.props.mode ?? 'missions',
            bodyKey: this.props.bodyKey ?? 1,
            key: 1,
            inOutRow: {},
            inOutPopVisible: false,
            dealPopVisible: false,
            viewDealDocumentsKey: 1,
            focusedDeal: { id: 0 },
            dealsGridKey: 1,
            inOutGrdKey: 1,
        }
        this.renderModeRelatedComponent = this.renderModeRelatedComponent.bind(this);
    }

    // onClickBodySelector = item => {
    //     this.setState({ bodySid: item?.itemData?.sid })
    // }

    checkConnection = () => {
        console.log('check connection...');

        let onFailed = err => {
            window.setTimeout(this.checkConnection, 1000);
            window.onServerFailed('not_ok');
            window.onServerFailed?.(err);
        }

        apiGetP('/api/logon/checkConnection')
            .then(res => {
                let s = res?.resp ?? res;
                if (s != 'ok') {
                    onFailed('not_ok');
                    return;
                }

                window.clearTimeout();
                console.log('connection is ok.');
                this.setState({ serverIsConnected: true })
            })
            .catch(onFailed);
    }


    onEditMoneyInOut = inOutRow => {
        this.setState({ inOutPopVisible: true }); ////////////////
    }

    onDeleteMoneyInOut = () => {
        if (confirm('واقعاً خذف شود؟', 'هشدار'))
            apiDeleteP(`/api/dyna/deleteRow/MoneyInOut/${this.state.inOutRow?.id}`)
                .then(() => this.setState({ inOutGrdKey: this.state.inOutGrdKey + 1 }))
                .catch(window.notif)
    }

    onSaveMoneyInOut = save => {
        if (save === false) {
            AuxFile.manageTemporaries('MoneyInOut', 'remove', this.state.inOutRow?.id);
            this.setState({ inOutPopVisible: false });
            return;
        }

        if (!this.state.inOutRow)
            return;

        apiPostP('/api/tarabar/saveRow/MoneyInOut', this.state.inOutRow)
            .then(res => {
                res ??= { error: 'No response.' };
                console.log(res);

                if (res.error?.length > 0) {
                    window.notif(res.error);
                    return;
                }
                window.notif('ذخیره شد');
                //let pastId = this.state.focusedDeal.id ?? 0;
                this.state.inOutRow.id = res.row?.id;
                //AuxFile.manageTemporaries('Deal', pastId == 0 ? 'add' : 'keep', this.state.focusedDeal.id);
                this.setState({ inOutPopVisible: false });
            }).catch(window.notif);
    }

    onSaveInOut = save => {
        this.onSaveMoneyInOut(save);
        return; //////////////////////////////////////////////
        if (save === false) {
            AuxFile.manageTemporaries('MoneyInOut', 'remove', this.state.inOutRow?.id);
            this.setState({ inOutPopVisible: false });
            return;
        }

        apiPostP('/api/tarabar/saveRow/MoneyInOut', this.state.inOutRow)
            .then(res => {
                res ??= { error: 'No response.' };
                console.log(res);

                if (res.error?.length > 0) {
                    window.notif(res.error);
                    return;
                }
                window.notif('ذخیره شد');
                //AuxFile.manageTemporaries('MoneyInOut', 'keep', this.state.inOutRow?.id);
                this.setState({ inOutPopVisible: false });
            }).catch(window.notif);
        return;
    }

    onEditDeal = () => {
        this.setState({ dealPopVisible: true });
    }

    onDeleteDeal = () => {
        if (confirm('واقعاً خذف شود؟', 'هشدار'))
            apiDeleteP(`/api/dyna/deleteRow/Deal/${this.state.focusedDeal?.id}`)
                .then(() => this.setState({ dealsGridKey: this.state.dealsGridKey + 1 }))
                .catch(window.notif)
    }

    onSaveDeal = save => {
        if (save === false) {
            AuxFile.manageTemporaries('Deal', 'remove', this.state.focusedDeal?.id);
            this.setState({ dealPopVisible: false });
            return;
        }

        if (!this.state.focusedDeal)
            return;

        apiPostP('/api/tarabar/saveRow/Deal', this.state.focusedDeal)
            .then(res => {
                res ??= { error: 'No response.' };
                console.log(res);

                if (res.error?.length > 0) {
                    window.notif(res.error);
                    return;
                }
                window.notif('ذخیره شد');
                //let pastId = this.state.focusedDeal.id ?? 0;
                this.state.focusedDeal.id = res.row?.id;
                //AuxFile.manageTemporaries('Deal', pastId == 0 ? 'add' : 'keep', this.state.focusedDeal.id);
                this.setState({ dealPopVisible: false });
            }).catch(window.notif);
    }

    renderModeRelatedComponent(mode) {
        let width = `calc(${Math.round(SideDivider.bodyWidth * 0.95)}px - 3rem)`;
        switch (mode) {
            case 'missions':
                return (
                    <Missions width={width} />
                );
            case 'money_in_out':
                return (
                    <>
                        <UniGrid table='MoneyInOut' readOnly width={width} key={'inoutGrd_' + this.state.inOutGrdKey}
                            title='واریز/برداشت سهامداران'
                            onFocusedRowChanged={inOutRow => this.setState({
                                inOutRow, viewMoneyInOutDocumentsKey: 1 + (this.state.viewMoneyInOutDocumentsKey ?? 0)
                            })}
                            focusedRow={this.state.inOutRow}

                            buttonColumns={[
                                {
                                    locateAtBefore: true, icon: '', width: '5em',
                                    textOfRow: x => (
                                        <Inline spacing='0.7em'>
                                            <FontAwesomeIcon icon='trash' type='solid' fontSize='0.8em' onClick={() => this.onDeleteMoneyInOut(x)} />
                                            <FontAwesomeIcon icon='pencil' type='solid' fontSize='0.8em' onClick={() => this.onEditMoneyInOut(x)} />
                                        </Inline>
                                    )
                                },
                            ]}

                            editingForm_ExtraItems={[
                                <SimpleItem>
                                    <Uploader selectButtonText={'بارگذاری اسناد...'}
                                        subPath={AuxFile.getTempPath('MoneyInOut', this.state.inOutRow?.id)}
                                    />
                                </SimpleItem>
                            ]}
                        />
                        <Inline spacing='5px' margin='1rem'>
                            <Button text='ثبت واریزی' width='10rem' type='success'
                                onClick={() => this.setState({ inOutRow: { id: 0, direction: 1 }, inOutPopVisible: true })} />
                            <Button text='ثبت برداشت' width='10rem' type='danger'
                                onClick={() => this.setState({ inOutRow: { id: 0, direction: -1 }, inOutPopVisible: true })} />
                        </Inline>
                        <ViewDocuments table='MoneyInOut' rowId={this.state.inOutRow?.id ?? 0} width={width} opened={false}
                            key={`${this.state.viewMoneyInOutDocumentsKey ?? 0}_view_doc_inout_${this.state.inOutRow?.id ?? 0}`}
                        />
                    </>
                );
            case 'deals':
                return (
                    <>
                        <UniGrid table='Deal' width={width} readOnly key={'dealGrd_' + this.state.dealsGridKey}
                            title='معاملات'
                            onFocusedRowChanged={focusedDeal => this.setState({
                                focusedDeal, viewDealDocumentsKey: 1 + (this.state.viewDealDocumentsKey ?? 0)
                            })}
                            focusedRow={this.state.focusedDeal}

                            // onEditCanceled={() => this.onMissionSavedOrCanceled(false)}
                            // onSaved={() => this.onMissionSavedOrCanceled(true)}
                            // customColumns={[
                            //     {
                            //         name: 'auxFiles',
                            //         caption: 'اسناد ضمیمه',
                            //         width: '6rem',
                            //         cellRender: _ =>
                            //             <Button text='...' width='100%' height='100%' stylingMode='text'
                            //                 onClick={() => this.setState({ viewDealDocumentsKey: 1 + (this.state.viewDealDocumentsKey ?? 0) })}
                            //             />
                            //     }
                            // ]}

                            buttonColumns={[
                                {
                                    locateAtBefore: true, icon: '', width: '5em', textOfRow: x => (
                                        <Inline spacing='0.7em'>
                                            <FontAwesomeIcon icon='trash' type='solid' fontSize='0.8em' onClick={() => this.onDeleteDeal(x)} />
                                            <FontAwesomeIcon icon='pencil' type='solid' fontSize='0.8em' onClick={() => this.onEditDeal(x)} />
                                        </Inline>
                                    )
                                },
                            ]}

                            editingForm_ExtraItems={[
                                <SimpleItem>
                                    <Uploader selectButtonText={'بارگذاری اسناد...'}
                                        subPath={AuxFile.getTempPath('Deal', this.state.focusedDeal?.id)}
                                    />
                                </SimpleItem>
                            ]}
                        />

                        <Inline spacing='5px' margin='2rem' style={{ justifyContent: 'center' }}>
                            {...Deal.types.map(d =>
                                <Button text={d.summary} width='10rem' type='success'
                                    onClick={() => this.setState({ focusedDeal: { id: 0, dealtype: d.id }, dealPopVisible: true })}
                                />)}
                        </Inline>

                        <ViewDocuments table='Deal' rowId={this.state.focusedDeal?.id ?? 0} width={width} opened={false}
                            key={`${this.state.viewDealDocumentsKey ?? 0}_view_doc_deal_${this.state.focusedDeal?.id ?? 0}`}
                        />
                    </>
                );
            case 'drivers':
                return (
                    <UniGrid table='TaraDriver' width={width} title='رانندگان/ماشینها'
                    />
                );
            case 'transit_points':
                return (
                    <UniGrid table='TransitPoint' width={width} title='مبدأ / مقصد'
                    />
                );
            case 'customers':
                return (
                    <UniGrid table='Customer' width={width} title='مشتریان' />
                );
            case 'remittances':
                return (
                    <UniGrid table='Remittance' width={width} title='حواله ها' />
                );
            case 'shareholders':
                return (
                    <UniGrid table='ShareHolder' width={width} title='سهامداران' />
                );
            case 'materials':
                return (
                    <UniGrid table='Material' width={width} title='مواد' />
                );
            case 'tankers':
                return (
                    <UniGrid table='Tanker' width={width} title='تانکرها' />
                );
            case 'shareholder_reports':
                return (
                    <ShareHolderReports width={width} />
                );
            case 'customer_reports':
                return (
                    <CustomerReports width={width} />
                );
            case 'driver_reports':
                return (
                    <DriverReports width={width} />
                );
            case 'tanker_reports':
                return (
                    <TankerReports width={width} />
                );
            case 'users':
                return (
                    <h1 style={{ marginTop: '35vh', color: 'gray' }}>در حال ساخت ...</h1>
                );
            default:
                return (
                    <p style={{ padding: '3rem' }}>Unknown Mode: {mode}</p>
                );
        }
    }

    componentDidMount() {
        this.checkConnection();
    }

    render() {
        //window.user = { id: 1, isadmin: true }; ////////////////////////////////////////////////////

        if (this.state.mode == '')
            return (<Welcome onEnter={() => this.setState({ mode: 'logon' })} />);

        if (this.state.serverIsConnected !== true)
            return (
                <h2 style={{ direction: 'rtl', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'red' }}
                >
                    <FontAwesomeIcon icon='spinner' spin style={{ margin: '0 1rem' }} />
                    در انتظار پاسخ سرور ...
                </h2>
            );

        if (!this.props.innerBody && !this.state.mode || this.state.mode === 'logon' || !(window.user?.id > 0))
            return (
                <TarabarLogon onSuccessLogon={
                    user => {
                        console.log(user);
                        this.setState({ mode: 'missions' });
                    }
                }
                />
            );

        console.log('Home: mode=', this.state.mode, ', status=', this.props.status, ', bodyKey=', this.state.bodyKey, ', state=', this.state);

        let body = this.props.innerBody ??
            <>
                <Popup key='inoutPop' visible={this.state.inOutPopVisible} width='50rem' height='auto' rtlEnabled
                    title={this.state.inOutRow?.direction > 0 ? 'ثبت برداشت' : 'ثبت واریزی'}
                    onHiding={() => this.setState({ inOutPopVisible: false })}
                >
                    <MoneyInOut row={this.state.inOutRow} readOnlyShareHolder={this.state.inOutRow?.fk_shareholder > 0} />
                    <br />
                    <Button text='ذخیره' onClick={this.onSaveInOut} width='10rem'
                    />
                    <Button text='انصراف' width='10rem' onClick={() => this.onSaveInOut(false)}
                    />
                </Popup>

                <Popup visible={this.state.dealPopVisible} key={`dealpop_${this.state.focusedDeal?.id ?? 0}_${this.state.dealPopVisible ?? false}`}
                    width='50rem' height='auto' rtlEnabled
                    title={Deal.types.find(x => x.id == this.state.focusedDeal?.dealtype)?.summary}
                    onHiding={() => this.setState({ dealPopVisible: false })}
                >
                    <Deal row={this.state.focusedDeal} key={'dealpoprow_' + (this.state.focusedDeal?.id ?? 0) + '_' + (this.state.focusedDeal?.dealtype ?? 0)} />
                    <br />
                    <Button text='ذخیره' onClick={this.onSaveDeal} width='10rem'
                    />
                    <Button text='انصراف' width='10rem' onClick={() => this.onSaveDeal(false)}
                    />
                </Popup>

                <div style={{ margin: ' 0 1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}
                >
                    {this.renderModeRelatedComponent(this.state.mode)}
                </div>
            </>

        return (
            <MasterLayout body={body} bodyKey={this.state.bodyKey}
                noTopMenu noUserIcon headerHeight={60}
                sideMenuUrl={`/api/tarabar/sideMenu/${window.user?.id}`}
                //containerStyle={{ backgroundImage: 'url(/images/logon.jpg)' }}
                headerFarItems={
                    <Inline spacing='0.5rem' style={{ height: '60px' }}>
                        <FontAwesomeIcon icon='palette' fontSize='1.2rem' hint='تغییر تم'
                            onClick={
                                () => {
                                    Theme.SetNext();
                                    window.reload();
                                }}
                        />
                        <div id='user-name-banner'>
                            {/* {`${ this.props.userName ?? this.state.userText ?? `${window.user?.role}-${window.user?.userName}` }`} */}
                            {`${window.user?.userName ?? ''} ${this.state.userText ?? ''}`}
                        </div>
                        <MinimalButton icon='fa-power-off' style={{ fontSize: '1.2em', width: '30px' }} highlightedColor='red'
                            onClick={() => {
                                window.user = { id: 0 };
                                this.setState({ mode: 'logon' });
                            }}
                        />
                    </Inline >
                }
                key={`masl_${this.state.key}_${this.state.bodyKey}_${this.props.status}__${this.state.inOutPopVisible}__${this.state.dealPopVisible}`}/////////////
                headerNearItems={
                    [
                        // <div style={{ width: '6rem', fontSize: '14px', fontWeight: '900' }}>تابلو بار عمومی</div>,
                        // <div style={{ width: '6rem', fontSize: '14px', fontWeight: '900' }} key={2}>درباره ما</div>,
                        // <div style={{ width: '6rem', fontSize: '14px', fontWeight: '900' }} key={3}>تماس با ما</div>
                    ]}
            />
        );
    }
}

export default Home;

/* 
    <MinimalButton rtlEnabled={true} height='100%' width='3rem' stylingMode='text'
        onClick={this.props.onUserIconClick}
    >
        <Inline>
            <span>
                {window.user?.fullname ?? window.user?.username ?? window.user?.name ?? '&npsp;'}
            </span>
            <FontAwesomeIcon icon='circle-user' beatFade fontSize='1.3rem' />
        </Inline>                        
    </MinimalButton>                 
*/